module.exports = __webpack_public_path__ + "img/icon1_highlight.80a288d5.png";